import { FC } from 'react'

import { ModalSectionProps } from '../utils'
import { NeedsAssigned } from 'screens/Rostering/formComponents'
import useResidentsList from 'hooks/useResidentsList'
import useResidentNeeds from 'hooks/useResidentNeeds'

export const NeedsAssignedSection: FC<ModalSectionProps> = ({ formData }) => {
  const selectedResident = formData?.subjectId

  const { residents } = useResidentsList({})

  const resident = residents?.find(
    (resident) => selectedResident === resident.id
  )

  const { needs, isLoading } = useResidentNeeds({ id: selectedResident })

  return (
    <NeedsAssigned
      name={`${resident?.name?.first || ''} ${resident?.name?.last || ''}`}
      tags={needs?.map((need) => need?.need?.name)}
      isLoading={isLoading}
    />
  )
}
